module.exports = __webpack_public_path__ + "static/media/emily-addison.ac231352.jpg";